import { Injectable } from '@angular/core';
import { UserContextService } from 'src/app/services/user-context.service';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { FlightWatchUserContext } from '../models/flight-watch-user-context.interface';

@Injectable({
    providedIn: 'root'
})
export class FlightWatchUserContextService {
    constructor(private userContextService: UserContextService) {}

    /**
     * Gets flight watch specific user context
     * Type-safe - uses constant keys, no raw strings
     * @returns User context with ICAO, FBO ID, FBO name, and group ID
     */
    getUserContext(): FlightWatchUserContext {
        // Type-safe - uses constant keys, no raw strings allowed
        const context = this.userContextService.getContextSubset([
            localStorageAccessConstant.icao,
            localStorageAccessConstant.fboId,
            localStorageAccessConstant.fbo,
            localStorageAccessConstant.groupId
        ]);
        
        return {
            selectedICAO: context.icao,
            fboId: context.fboId,
            fboName: context.fbo,
            groupId: context.groupId,
        };
    }
}

